
jQuery(document).ready( function($){

	var xhr;

	$('#search-box').bind( 'keyup focus', function(e){
		if( $(this).val().length > 1 ) {
			if( xhr && xhr.readystate != 4 ) xhr.abort();
			xhr = $.get( '/admin/search-modules', { keyword : $(this).val() }, function( response ){
				var list = $('<div />').addClass('ui list');
				if( response.length ) {
					for( var i in response ) {
						var model = response[i];
						var row = $('<div />').addClass('item');
						var link = $('<a />')
							.addClass('description')
							.attr('href', model.direct_link)
							.text( model.text_prefix + model.name_property )
						link.appendTo(row);
						row.appendTo(list);
					}
				} else {
					var row = $('<div />').addClass('item').text('Sorry, no results found');
					row.appendTo(list);
				}
				$('#search-results').remove();
				list.attr('id', 'search-results').appendTo($('body'));

				var searchBox = $('#search-box');
				var searchBoxOffset = searchBox.offset();
				list.css({
					'position' : 'absolute',
					'z-index' : '99999999999999',
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'right' : $(window).width() - ( searchBoxOffset.left + searchBox.outerWidth() ) + 'px',
					'width' : ( searchBox.outerWidth() + 47 ) + 'px'
				});
			});
		}
	});

	$(document).click(function(e){
		if( ! $(e.target).parents('#search-results:eq(0)').length ) {
			$('#search-results', $('body')).remove();
		}
	});

});
